<template>
  <div class="main-content">
    <ScrollPanel class="scroll-panel">
      <template v-if="!isAuthenticated">
        <h2>Sphere Admin</h2>

        <p>Log in to manage your Sphere instance.</p>
      </template>
      <p v-else-if="!selectedAccount">Please select a Sphere to continue.</p>
      <RouterView v-else />
    </ScrollPanel>
  </div>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { selectedAccount } from "../store/state.js";

const { isAuthenticated } = useAuth0();
</script>

<style scoped>
@media (max-width: 1023px) {
  .main-content {
    padding: .5rem;
  }
  .main-content .scroll-panel {
    height: auto;
  }
}
@media (min-width: 1024px) {
  .main-content {
    flex-basis: 80%;
  }
  .main-content .scroll-panel {
    height: 80vh;
  }
}
</style>
